import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-AwsLambda',
    templateUrl: './AwsLambda.component.html'
})
export class AwsLambdaComponent implements OnInit {

    consumerID: string;
    timeout: 60000;
    keepalive = 60000;
    aws_key: string;
    aws_secret: string;
    function_name: string;
    qualifier: string;
    port = 443;
    unhandled_status: number;
    forward_request_method = false;
    forward_request_uri = false;
    forward_request_headers = false;
    forward_request_body = false;
    is_proxy_integration = false;
    log_type = 'Tail';
    invocation_type = 'RequestResponse';
    aws_region = 'us-east-1';

    data = {
        'consumerID' : this.consumerID,
        'timeout' : this.timeout,
        'keepalive' : this.keepalive,
        'aws_key' : this.aws_key,
        'aws_secret' : this.aws_secret,
        'function_name' : this.function_name,
        'qualifier' : this.qualifier,
        'port' : this.port,
        'unhandled_status' : this.unhandled_status,
        'forward_request_method' : this.forward_request_method,
        'forward_request_uri' : this.forward_request_uri,
        'forward_request_headers' : this.forward_request_headers,
        'forward_request_body' : this.forward_request_body,
        'is_proxy_integration' : this.is_proxy_integration,
        'log_type' : this.log_type,
        'invocation_type' : this.invocation_type,
        'aws_region' : this.aws_region,
        'plugin' : 'aws-lambda'
    };

    constructor() { }

    slider() {
        this.forward_request_method = !this.forward_request_method;
    }
    slider1() {
        this.forward_request_uri = !this.forward_request_uri;
    }
    slider2() {
        this.forward_request_headers = !this.forward_request_headers;
    }
    slider3() {
        this.forward_request_body = !this.forward_request_body;
    }
    slider4() {
        this.is_proxy_integration = !this.is_proxy_integration;
    }

    ngOnInit() {
    }

}
